import config from '@plone/volto/registry';

import type { AgentClient } from './AgentClient';
import { HttpAgentClient } from './HttpAgentClient';
import { MockAgentClient } from './MockAgentClient';

export { canonicalPagePathname, AGENT_VERSION } from './AgentClient';

let instance: AgentClient | null = null;

/**
 * The one client the UI talks to.
 *
 * A customer's own client, registered with `aiEditor(config).useClient(...)`,
 * wins. Otherwise the setting decides: the real agent through the express
 * proxy by default, the offline in-browser mock when the demo should run
 * without a backend (`RAZZLE_AI_EDITOR_CLIENT=mock`).
 *
 * Resolved once and cached, because the active conversation lives on the
 * instance — a fresh client every call would forget which conversation is
 * running.
 */
export function agentClient(): AgentClient {
  if (instance) return instance;

  const settings = (config.settings as Record<string, any>).aiEditor || {};
  instance =
    settings.registry?.client ||
    (settings.client === 'mock'
      ? new MockAgentClient()
      : new HttpAgentClient());

  return instance!;
}

/** Test-only: drop the cached client so the next call resolves again. */
export function resetAgentClient(): void {
  instance = null;
}
